import { useEffect, useState } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Gallery from "@/components/Gallery";
import BeforeAfter from "@/components/BeforeAfter";
import Services from "@/components/Services";
import About from "@/components/About";
import Testimonials from "@/components/Testimonials";
import ContactForm from "@/components/ContactForm";
import PaySection from "@/components/PaySection";
import Footer from "@/components/Footer";
import AlbumManager from "@/components/AlbumManager";
import { ALBUMS } from "@/data/portfolioData";

const STORAGE_KEY = "lumen_custom_albums";

function App() {
  const [customAlbums, setCustomAlbums] = useState([]);
  const [managerOpen, setManagerOpen] = useState(false);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const onClick = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      const hash = anchor.getAttribute("href");
      if (hash.length > 1 && document.querySelector(hash)) {
        e.preventDefault();
        lenis.scrollTo(hash, { offset: -72 });
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      cancelAnimationFrame(raf);
      document.removeEventListener("click", onClick);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    try {
      setCustomAlbums(JSON.parse(localStorage.getItem(STORAGE_KEY)) || []);
    } catch {
      setCustomAlbums([]);
    }
  }, []);

  const persist = (albums) => {
    setCustomAlbums(albums);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(albums));
  };

  const addAlbum = (album) => persist([...customAlbums, album]);
  const removeAlbum = (id) => persist(customAlbums.filter((a) => a.id !== id));

  const albums = [...ALBUMS, ...customAlbums];

  return (
    <div className="App">
      <Toaster position="top-center" theme="dark" richColors />
      <Navbar onOpenManager={() => setManagerOpen(true)} syncCount={customAlbums.length} />
      <Hero />
      <Marquee />
      <Gallery albums={albums} />
      <BeforeAfter />
      <Services />
      <About />
      <Testimonials />
      <ContactForm />
      <PaySection />
      <Footer />
      <AlbumManager
        open={managerOpen}
        onClose={() => setManagerOpen(false)}
        customAlbums={customAlbums}
        onAdd={addAlbum}
        onRemove={removeAlbum}
      />
    </div>
  );
}

export default App;
